module.exports = __webpack_public_path__ + "media/arrows/dashed-squiggle-arrow--blue-500-f9b1b823.svg";